import { FC, MouseEvent, useContext } from 'react';

import AddIcon from '@mui/icons-material/Add';
import AttachmentIcon from '@mui/icons-material/Attachment';
import BlockIcon from '@mui/icons-material/Block';
import EditOffIcon from '@mui/icons-material/EditOff';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Asset } from 'src/models/assets/asset';
import { authStoreCtx } from 'src/stores/auth';

import { useAssetsStore } from '../../AssetsProvider';

interface Props {
  collapsed: boolean;
  asset: Asset;
  uploadHandler: (id: number) => void;
  handleOpenList: (event: MouseEvent<HTMLElement>) => void;
  handleToggleCarousel: (event: MouseEvent<HTMLElement>) => void;
}

const CountItem: FC<Props> = observer(props => {
  const { fCfg } = useContext(authStoreCtx);

  const {
    collapsed,
    handleOpenList,
    handleToggleCarousel,
    asset: { id, totalAttachments, canUpdate, isRelatedEntityActive },
  } = props;
  const { chosenAsset } = useAssetsStore();

  const handleOpenCarousel = (event: MouseEvent<HTMLElement>) => {
    fCfg.isFilePreviewCarousel && handleToggleCarousel(event);
  };

  const handleUpload = () => {
    props.uploadHandler(id);
  };

  const attachmentsCount =
    chosenAsset?.id === id
      ? chosenAsset?.attachments.totalAttachments
      : totalAttachments;

  return (
    <Grid
      container
      alignItems="center"
      style={{
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        width: '100%',
        flex: 1,
        overflow: 'hidden',
        cursor: 'pointer',
      }}>
      <div style={{ flex: '0 0 auto', display: 'flex', alignItems: 'center' }}>
        {canUpdate && !isRelatedEntityActive && (
          <Tooltip title="Inactive activity">
            <BlockIcon fontSize="small" sx={{ verticalAlign: 'middle' }} />
          </Tooltip>
        )}
        {!canUpdate && (
          <Tooltip title="Read only asset">
            <EditOffIcon fontSize="small" sx={{ verticalAlign: 'middle' }} />
          </Tooltip>
        )}
        <IconButton
          name="view-btn"
          id="attach-button"
          size="medium"
          onClick={e => handleOpenCarousel(e)}>
          <AttachmentIcon
            fontSize="small"
            sx={{
              transform: 'rotate(-45deg)',
              color: 'text.secondary',
            }}
          />
        </IconButton>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flex: '1 1 auto',
          minWidth: 0,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        }}>
        <Typography variant="body1" sx={{ padding: '0 8px' }}>
          {attachmentsCount}
        </Typography>
      </div>
      <div style={{ flex: '0 0 auto', marginLeft: 'auto' }}>
        {attachmentsCount === 0 ? (
          <IconButton
            name="add-btn"
            disabled={!canUpdate || !isRelatedEntityActive}
            sx={{ color: 'text.secondary' }}
            size="medium"
            onClick={handleUpload}>
            <AddIcon />
          </IconButton>
        ) : (
          <IconButton
            id="basic-button"
            size="medium"
            name="file-btn"
            sx={{ color: 'text.secondary' }}
            aria-controls={collapsed ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={collapsed ? 'true' : undefined}
            onClick={handleOpenList}>
            {collapsed ? (
              <KeyboardArrowDownIcon fontSize="medium" />
            ) : (
              <KeyboardArrowUpIcon fontSize="medium" />
            )}
          </IconButton>
        )}
      </div>
    </Grid>
  );
});

export default CountItem;
